import { render, staticRenderFns } from "./pasargad-merchant-documents.vue?vue&type=template&id=10dbd600"
import script from "./pasargad-merchant-documents.vue?vue&type=script&lang=js"
export * from "./pasargad-merchant-documents.vue?vue&type=script&lang=js"
import style0 from "./pasargad-merchant-documents.vue?vue&type=style&index=0&id=10dbd600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports